import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { getLocaleStore } from '@/i18n/index';
import { base64Kit } from '@/utils/base64-kit';
import { imageConverter } from '@/utils/file-kit';
import { ILayerBehavior, ITableLayer, ITableLayerProps } from '@/version-types';
import TableLayer from '../view/table-layer';

type Behaviors = Pick<ILayerBehavior, 'render' | 'previewToImage' | 'getMenuOverlapName' | 'getMenuOverlapIcon'>;

export const createRendererBehaviors = (frameworkIdentity: string) => {
    const behaviors: Behaviors = {
        render(layer, extraProps) {
            return <TableLayer layer={layer as ITableLayer} {...extraProps} />;
        },

        previewToImage: () => false,

        getMenuOverlapName() {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.table);
        },

        getMenuOverlapIcon(layer) {
            const { screenshotUrl: tableScreenshotUrl } = layer.data as ITableLayerProps;
            return (
                <div className="l-layer__icon">
                    {tableScreenshotUrl ? (
                        <img src={imageConverter(base64Kit.getLocalUrl(tableScreenshotUrl), 32, 100)} alt="" />
                    ) : (
                        <IconFont name="TabulationBold" fontSize={16} />
                    )}
                </div>
            );
        },
    };

    return behaviors;
};
